
import Hero from './components/Hero';
import MakingThings from './components/MakingThings';
import WhatWeDo from './components/WhatWeDo';
import MirariEchoBanner from './components/MirariEchoBanner';
import WhyBitmoves from './components/WhyBitmoves';
import SelectedWorks from './components/SelectedWorks';
import Contact from './components/Contact';
import SharedFooter from '../../components/feature/SharedFooter';
import SharedNavigation from '../../components/feature/SharedNavigation';

export default function Home() {
  return (
    <div className="relative">
      <SharedNavigation />
      <Hero />
      <MakingThings />
      <WhatWeDo />
      <MirariEchoBanner />
      <WhyBitmoves />
      <SelectedWorks />
      <Contact />
      <SharedFooter showAbout />
    </div>
  );
}
